import "./util/chunkReloadHandler"
import ReactDOM from "react-dom/client"
import Retroboard from "./components/Retroboard"
import { initSentry } from "./sentry"
import "./i18n"
import "./sass/retroboard.scss"

initSentry()

ReactDOM.createRoot(document.getElementById("retroboard")!).render(<Retroboard />)
